@switch (field.input_type) {
  @case (FieldInputType.INLINE) {
    @for (subField of field.sub_fields; track subField.name; let i = $index) {
      <app-edit-field-inline-field
        [displayRequiredIndication]="displayRequiredIndication"
        [subFieldIndex]="i"
        [sectionsContainer]="sectionsContainer"
        [grandParentObject]="myObject"
        [object]="myObject[field.name]"
        [field]="subField"
        [index]="index"
        [parentIndex]="parentIndex"
      ></app-edit-field-inline-field>
    }
  }
  @case (FieldInputType.INLINE_ARRAY) {
    <app-edit-field-inline-array
      [displayRequiredIndication]="displayRequiredIndication"
      [sectionsContainer]="sectionsContainer"
      [object]="myObject"
      [field]="field"
      (fieldOutsideTheScreen)="checkIfFieldOutsideTheScreen()"
      [grandparentIndex]="parentIndex"
      [parentIndex]="index"
    ></app-edit-field-inline-array>
  }
  @case (FieldInputType.CONTEXT) {
    @if (sectionsContainer.isDialog) {
      <app-edit-field-context
        [contexts]="sectionsContainer.rootObject[field.name]"
        [isLocationOperation]="isLocationOperation"
        [operationContext]="sectionsContainer.operationContextObjects"
        [field]="field"
      ></app-edit-field-context>
    }
  }
  @case (FieldInputType.ACTION_BUTTON) {
    <app-field-action-button
      class="section-field__action-button"
      [sectionsContainer]="sectionsContainer"
      [object]="myObject"
      [field]="field"
      [edit]="true"
      [parentIndex]="index"
      (closeEdit)="onCloseEdit()"
    ></app-field-action-button>
  }
  @case ('compare_value') {
    <app-edit-field-compare
      [displayRequiredIndication]="displayRequiredIndication"
      [sectionsContainer]="sectionsContainer"
      [field]="field"
      [parentIndex]="parentIndex"
      [index]="index"
    ></app-edit-field-compare>
  }
  @case (FieldInputType.META_OPERATION_FIELD) {
    @if (operationField) {
      <app-edit-field-meta-operation-field
        [displayRequiredIndication]="displayRequiredIndication"
        [sectionsContainer]="sectionsContainer"
        [field]="field"
        [setAddChoice]="sectionsContainer.rootObject['set_add_choice']"
        [setValueObject]="setValueObject"
        [selectedFieldId]="setValueObject['select_field']"
        [operationField]="operationField"
        [parentIndex]="parentIndex"
        [index]="index"
      ></app-edit-field-meta-operation-field>
    }
  }
  @default {
    <app-edit-field
      [displayRequiredIndicaton]="displayRequiredIndication"
      [sectionsContainer]="sectionsContainer"
      [grandParentObject]="grandParentObject"
      [object]="myObject"
      [field]="field"
      [index]="index"
      [parentIndex]="parentIndex"
      [grandparentIndex]="grandparentIndex"
    ></app-edit-field>
  }
}
